export const professionList = {
  professionMarketing: 'Coordinador de màrqueting',
  professionWebDesigner: 'Dissenyador web',
  professionSales: 'President de vendes',
  professionCoordinator: 'Coordinador de màrqueting',
};

export const pageTitle = 'El nostre equip';
